module.exports = __webpack_public_path__ + "assets/b6c04d5e013303e5405f1b46acbcd899.mp3";